import { render } from "./login.vue?vue&type=template&id=23dfd0dc&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=23dfd0dc&lang=less&scoped=true"

import exportComponent from "/Users/yangjinlong/shthn/zzdxs-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dfd0dc"]])

export default __exports__